import mixpanel from "mixpanel-browser";
import WorkspaceService from "@/src/api/WorkspaceService.js";
import { mixpanelEmitters } from "@/src/constants/appConstants.js";

export default {
  init(token) {
    try {
      if (process.env.NODE_ENV === "production") {
        mixpanel.init(token, {
          debug: false,
          track_pageview: false,
          persistence: "localStorage",
        });
      } else {
        console.log("Mixpanel initialized in development mode (no tracking)");
      }
    } catch (error) {
      console.error("An error occurred while initializing Mixpanel: ", error);
    }
  },

  identify(userId) {
    try {
      if (process.env.NODE_ENV === "production") {
        mixpanel.identify(userId);
      } else {
        console.log("Mixpanel initialized in development mode (no tracking)");
      }
    } catch (error) {
      console.error("An error occurred while identifying user: ", error);
    }
  },

  setProfile(properties) {
    try {
      if (process.env.NODE_ENV === "production") {
        mixpanel.people.set(properties);
      } else {
        console.log("Mixpanel initialized in development mode (no tracking)");
      }
    } catch (error) {
      console.error("An error occurred while setting profile: ", error);
    }
  },

  getCommonProperties() {
    try {
      const commonProperties = {
        Emitter: mixpanelEmitters.CLIENT,
        Timestamp: new Date().toISOString(),
        Path: window.location.pathname,
      };

      if (typeof window !== "undefined") {
        const user =
          localStorage.getItem("userName") ||
          localStorage.getItem("userEmail") ||
          "Unknown";

        return {
          User: user,
          Email: localStorage.getItem("userEmail"),
          "User ID": localStorage.getItem("userId"),
          "Workspace ID": WorkspaceService.getCurrentWorkspaceId(),
          "New User": localStorage.getItem("newUser") || null,
          ...commonProperties,
        };
      }

      return {
        User: "Unknown",
        Email: null,
        "User ID": null,
        "Workspace ID": null,
        "New User": null,
        ...commonProperties,
      };
    } catch (error) {
      console.error(
        "An error occurred while getting common properties: ",
        error,
      );
    }
  },

  track(eventName, properties = {}) {
    try {
      if (process.env.NODE_ENV === "production") {
        const props = {
          ...this.getCommonProperties(),
          ...properties,
        };

        mixpanel.track(eventName, props);
      } else {
        console.log("Mixpanel initialized in development mode (no tracking)");
      }
    } catch (error) {
      console.error("An error occurred while tracking event: ", error);
    }
  },

  trackPageView(pageName, properties = {}) {
    try {
      if (process.env.NODE_ENV === "production") {
        mixpanel.track("Page Viewed", {
          ...this.getCommonProperties(),
          "Page Name": pageName,
          ...properties,
        });
      } else {
        console.log("Mixpanel initialized in development mode (no tracking)");
      }
    } catch (error) {
      console.error(
        "An error occurred while tracking page view event: ",
        error,
      );
    }
  },
};
